import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import TabSet from './TabSet';
import Footer from '../../components/Footer';
import { useAuthUserContext } from '../../providers';
import { useTitle } from '../../hooks/useTitle';

const RegisterIndex = () => {
  const { user } = useAuthUserContext();
  const navigate = useNavigate();

  useTitle('Ton Bébé | 新規登録');

  useEffect(() => {
    if (user) {
      navigate('/mypage');
    }
  }, [ user, navigate ]);

  return (
    <div>
      <Header />
      <main className="sub">
        <section className="register">
          <h1 className="sec_title">新規登録</h1>
          <TabSet />
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default RegisterIndex;
